import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notifyMeta } from '@/lib/notify';
import { CHAT_KEYS, CHAT_MONITOR_KEYS } from '@/constants/queryKeys';
import { conciergeThreadService } from '@/services/conciergeThread';
import { errorUtils } from '@/services/errors';

const syncMemberThread = async (memberID: string) => errorUtils.unwrap(await conciergeThreadService.syncMember(memberID));

const syncMemberThreads = async (memberIDs: readonly string[]): Promise<number> => {
  const threads = await Promise.all(memberIDs.map(syncMemberThread));

  return threads.filter(Boolean).length;
};

const useSyncMemberThreads = () => {
  const queryClient = useQueryClient();

  return useMutation<number, Error, readonly string[]>({
    meta: notifyMeta('memberThreadSync'),
    mutationKey: ['chat', 'syncMemberThreads'],
    mutationFn: syncMemberThreads,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: CHAT_KEYS.root }),
        queryClient.invalidateQueries({ queryKey: CHAT_MONITOR_KEYS.root }),
      ]);
    },
  });
};

export {
  useSyncMemberThreads,
};
